import { BaseEntity, User } from '@/types';

export interface TeamStatusBox {
  state: number;
  season: number;
  division: number;
  standings?: Standings;
}

export type TeamMember = {
  captain: boolean;
  user: User;
} & BaseEntity;

interface Standings {
  stand_win?: number;
  stand_lose?: number;
  stand_division?: string;
  stand_season?: number;
}

export enum TeamLeagueState {
  NotInActiveLeague = 0,
  InActiveLeagueButNotPaid = 1,
  InActiveLeagueAndPaid = 2,
  InRegularSeason = 3,
  InPlayoffs = 4,
}

export interface TeamSubscription {
  id: number;
  status: string;
  currentPeriodStart: number | null;
  currentPeriodEnd: number | null;
  cancelAtPeriodEnd: boolean;
  priceId: string | null;
  amount: number | null;
}
